import { render, staticRenderFns } from "./YWK_MigBoardList.vue?vue&type=template&id=3cd6d924"
import script from "./YWK_MigBoardList.ts?vue&type=script&lang=ts&external"
export * from "./YWK_MigBoardList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports